export const SHOP_USE_PREPOPULATE = ['lune-sans-blocks.myshopify.com', 'nook-site.myshopify.com', 'qp2ybw-jy.myshopify.com'];

export const HIDE_VALIDATE_ZIP_CODE_SHOP = ['qbakes.myshopify.com', 'd8a7ab-d0.myshopify.com', 'the-place-toronto.myshopify.com'];

export const CUSTOM_SHOP_LABEL_MAP: Record<string, string> = {
  'the-loon-mn.myshopify.com': '11:59 PM',
};

export const CUSTOM_SHOP_PLAN_CHECKOUT_PAGE = ['msuz42-5r.myshopify.com']
